import React, { useState } from "react";
import Heart from "./Heart";
import Loader from "./Loader";
import imgIcon from "../img/img_icon.svg";

export default function Image({ img, title, description, id, showFullSize }) {
  const [loaded, setLoaded] = useState(false);
  function hideLoader() {
    setTimeout(() => {
      setLoaded(true);
    }, 100);
  }
  function handleClick(e) {
    showFullSize(img);
  }

  const cls = loaded ? "col-4 imgholder" : "col-4 imgholder hidden";

  return (
    <div className={cls}>
      {loaded ? null : <Loader />}
      <img
        src={`${process.env.PUBLIC_URL}/pictures/${img}`}
        alt={title}
        onLoad={() => hideLoader()}
      />

      <div className="img_desc ml3 mb4 mt3">
        <div className="text">
          <h4>{title}</h4>
          <p dangerouslySetInnerHTML={{ __html: description }}></p>
        </div>
        <div className="img_icons">
          <div className="heart_icon">
            <img
              src={imgIcon}
              alt="Vis bilde"
              className="imgIcon mouse"
              onClick={handleClick}
            />
          </div>
          <div className="heart_icon">
            <Heart title={title} pid={id} />
          </div>
        </div>
      </div>
    </div>
  );
}
